import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { getFooterConfig, getHeaderConfig } from "../utils/projectTemplateConfig";

const EMPTY = { template: null, viewConfigs: null, addresses: [] };

const resolveAddress = (addresses, addressId) => {
  if (!addressId || !Array.isArray(addresses)) return null;
  const match = addresses.find((addr) => String(addr.id) === String(addressId));
  return match || null;
};

export const useProjectTemplateConfig = ({ instanceUniqueId, viewKey }) => {
  const [state, setState] = useState({
    loading: true,
    error: null,
    data: EMPTY,
  });

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      if (!instanceUniqueId) {
        if (mounted) {
          setState({ loading: false, error: null, data: EMPTY });
        }
        return;
      }
      try {
        setState((prev) => ({ ...prev, loading: true, error: null }));
        const url = `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/project-templates/public/${instanceUniqueId}`;
        const res = await axios.get(url);
        if (!mounted) return;
        const payload = res?.data || {};
        setState({
          loading: false,
          error: null,
          data: {
            template: payload.template || null,
            viewConfigs: payload.viewConfigs || payload.template?.viewConfigs || null,
            addresses: payload.addresses || [],
          },
        });
      } catch (err) {
        if (!mounted) return;
        setState({
          loading: false,
          error: err,
          data: EMPTY,
        });
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, [instanceUniqueId]);

  const headerConfig = useMemo(
    () => getHeaderConfig(state.data.viewConfigs, viewKey),
    [state.data.viewConfigs, viewKey]
  );

  const footerConfig = useMemo(
    () => getFooterConfig(state.data.viewConfigs, viewKey),
    [state.data.viewConfigs, viewKey]
  );

  const footerAddress = useMemo(
    () => resolveAddress(state.data.addresses, footerConfig.addressId),
    [state.data.addresses, footerConfig.addressId]
  );

  return {
    ...state,
    headerConfig,
    footerConfig,
    footerAddress,
    termsHtml: footerConfig?.termsHtml || null,
  };
};
